import type { Editor } from "@tiptap/core";

const applyMarkdownFormat = (
  editor: Editor,
  wrap: { open: string; close: string },
) => {
  const { from, to } = editor.state.selection;
  if (from < to) {
    const selected = editor.state.doc.textBetween(from, to);
    editor
      .chain()
      .focus()
      .insertContent(`${wrap.open}${selected}${wrap.close}`)
      .run();
  } else {
    editor.chain().focus().insertContent(wrap.open).run();
  }
};

export const runFormat = (
  isWysiwyg: boolean,
  editor: Editor,
  config: { toggle: () => void; wrap: { open: string; close: string } },
) => {
  if (isWysiwyg) {
    config.toggle();
  } else {
    applyMarkdownFormat(editor, config.wrap);
  }
};
